<template>
  <div class="tubs-content">
    <ul v-if="platform.site" class="tabs justify-content-start mb-3">
      <li v-for="tab in modes" :key="tab" class="col-auto pl-1 pr-1">
        <button type="button" :class="{ active: mode === tab }" @click="selectMode(tab)">
          <template v-if="tab === 'self_hosted'">
            {{ $t("platform.self_hosted.title") }}
            <span class="badge-beta ml-1">Beta</span>
          </template>
          <template v-else>{{ $t("platform.standard_code") }}</template>
        </button>
      </li>
    </ul>
    <template v-if="mode === 'code'">
      <div class="code large">
        <div class="buttons-wrapper" :class="{ arbitrage: !platform.site }" v-if="isDesktop">
          <router-link v-if="platform.site && showSettingsLink" class="btn-settings _has-icon lower-link" exact :to="{ name: 'PlatformCard', params: { id: platform.id, tab: 'formats' } }">
            <svg v-svg symbol="settings-2" size="0 0 19 19" role="info"></svg>
          </router-link>
          <button type="button" class="btn-copy _has-icon lower-link" :class="{ 'only-button': !platform.site }" @click="copy">
            <span class="icon-copy m-0">
              <svg class="m-0" v-svg symbol="copy" size="0 0 13 15" role="info"></svg>
            </span>
          </button>
        </div>
        <code class="code__content">
          {{ platform.site ? code : link }}
        </code>
      </div>
      <div class="mobile-buttons-wrapper" v-if="!isDesktop">
        <router-link v-if="platform.site && showSettingsLink" class="btn-settings _has-icon lower-link" exact :to="{ name: 'PlatformCard', params: { id: platform.id, tab: 'formats' } }">
          <svg v-svg symbol="settings-2" size="0 0 19 19" role="info"></svg>
        </router-link>
        <button type="button" class="btn-copy _has-icon lower-link" :class="{ 'only-button': !platform.site }" @click="copy">
          <span class="icon-copy m-0">
            <svg class="m-0" v-svg symbol="copy" size="0 0 13 15" role="info"></svg>
          </span>
          {{ $t("copy") }}
        </button>
      </div>
    </template>
    <!-- v-show: keeps loading the status while hidden, it picks the tab to open -->
    <SelfHostedScript v-if="platform.site" v-show="mode === 'self_hosted'" :active="mode === 'self_hosted'" :platformId="platform.id" :customRedirect="customRedirect" :subParams="macrosesCode" @status="onSelfHostedStatus" />
    <!-- Sub params go to the standard code and to the self-hosted file URL alike -->
    <div class="macross" v-if="code && link">
      <div class="d-flex mt-4">
        <small class="add-macros" v-if="macroses.length">{{ $t("platforms.additional_parameters") }}:</small>
        <div class="macros-list">
          <div
            class="macros"
            :class="{
              active: platform.site ? code.includes(macros.value) : link.includes(macros.value),
            }"
            @click="toggleMacros(macros)"
            v-for="(macros, index) in macroses"
            :key="index"
          >
            {{ macros.value }}
          </div>
        </div>
      </div>
      <template v-if="!platform.site">
        <label class="mt-2">{{ $t("platforms.ready_templates") }}</label>
        <custom-multiselect v-model="templateModel" :list="templates" class="mb-3 templates">
          <template v-slot:block="props">
            <span v-if="props.value">
              {{ props.value.name }}
            </span>
            <span v-else>
              {{ $formatLabel("select_template") }}
            </span>
          </template>
          <template v-slot:list="props">
            <span>
              {{ props.value.name }}
            </span>
          </template>
        </custom-multiselect>
      </template>
    </div>
    <alert v-if="$alert.title" />
    <div class="hidden">
      <textarea readonly id="htttpsCopyLink" v-model="link" />
      <textarea readonly id="htttpsCopyCode" v-model="code" />
    </div>
  </div>
</template>
<script>
import "@/assets/css/_macros.scss";
import siteSettingsService from "@/api/siteSettingsService";
import { mapGetters } from "vuex";
import ServicePanel from "@/api/servicePanel";
import SelfHostedScript from "@/components/SelfHostedScript";

export default {
  name: "Code",
  components: { SelfHostedScript },
  props: {
    platform: {
      type: Object,
      default: null,
    },
    selectDomain: {
      type: Object,
      default: null,
    },
    showSettingsLink: {
      type: Boolean,
      default: true,
    },
    trafficSettings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDesktop: null,
      domain: "",
      templateModel: null,
      templates: [],
      macroses: [
        {
          name: "p1",
          value: "sub1",
        },
        {
          name: "p2",
          value: "sub2",
        },
        {
          name: "p3",
          value: "sub3",
        },
        {
          name: "p4",
          value: "sub4",
        },
      ],
      oldMacroses: {
        sub1: {
          enable: true,
          macros: "&p1=sub1",
        },
        sub2: {
          enable: true,
          macros: "&p2=sub2",
        },
        sub3: {
          enable: true,
          macros: "&p3=sub3",
        },
        sub4: {
          enable: true,
          macros: "&p4=sub4",
        },
      },
      customRedirect: false,
      urlParams: "",
      modes: ["code", "self_hosted"],
      mode: "code",
      modeSelected: false,
    };
  },
  watch: {
    selectDomain() {
      if (this.selectDomain.domain) {
        this.domain = this.selectDomain.domain;
      }
    },
    templateModel(val) {
      if (val) {
        const selectedTemplate = this.templates.find((el) => el.name == val.name);

        this.urlParams = selectedTemplate?.landing_url_params;

        if (!this.platform.site && val) this.macroses = [];
      } else {
        this.macroses = [
          {
            name: "p1",
            value: "sub1",
          },
          {
            name: "p2",
            value: "sub2",
          },
          {
            name: "p3",
            value: "sub3",
          },
          {
            name: "p4",
            value: "sub4",
          },
        ];
      }
    },
    domain() {
      this.oldMacroses = {
        sub1: {
          enable: true,
          macros: "&p1=sub1",
        },
        sub2: {
          enable: true,
          macros: "&p2=sub2",
        },
        sub3: {
          enable: true,
          macros: "&p3=sub3",
        },
        sub4: {
          enable: true,
          macros: "&p4=sub4",
        },
      };
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize");
  },
  mounted() {
    window.innerWidth > 768 ? (this.isDesktop = true) : (this.isDesktop = false);

    window.addEventListener("resize", (e) => {
      e.target.innerWidth < 768 ? (this.isDesktop = false) : (this.isDesktop = true);
    });

    if (!this.platform.site) {
      this.getUrlTemplates();
    }

    siteSettingsService.getFormats(this.platform.id).then((res) => {
      if (res && res.status === 200) {
        if (res.data.on_click) this.getOnClick(this.platform.id);
      }
    });
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
      featureFlags: "user/getFeatureFlags",
    }),
    macrosesCode() {
      let obj = Object.values(this.oldMacroses);
      let str = "";
      obj.forEach((e) => {
        if (e.enable) {
          str += e.macros;
        }
      });
      return str;
    },
    link() {
      const link = `https://${this.domain}/tds?id=${this.platform?.id}`;
      if (this.macroses.length > 0) {
        return link + this.macrosesCode;
      }
      return link + `&${this.urlParams}`;
    },
    trafficSettingsCondiditions() {
      const isEmpty = Object.values(this.trafficSettings.trafficback_urls).every((e) => e.length == 0);
      const urls = this.trafficSettings.trafficback_urls;
      const trafficbackUrls = {
        notSupported: urls.unsupported_input,
        permissionSkipped: urls.skiped_input,
        permissionDenied: urls.denied_input,
        subscribed: urls.allowed_input,
        subscriptionExists: urls.subscribed_input,
      };
      let result = "";
      if (isEmpty) {
        result = "// Add at least one URL.";
      } else {
        for (const [key, value] of Object.entries(trafficbackUrls)) {
          if (value !== "") {
            if (result !== "")
              result += `
          `;
            result += `case '${key}':
              window.location.replace("${value}");
              break;`;
          }
        }
        result = `switch (e.detail.state) {
          ${result}
      }`;
      }
      return result;
    },
    code() {
      let code = `
  <script type="text/javascript" src="https://${this.domain}/process.js?id=${this.platform.id}${this.macrosesCode}" async> &lt;/script>`;

      const customRedirect = `
  <script>
    var userCustomRedirectUrl = "PUT YOUR HTTP[S] URL HERE";
  &lt;/script>
      `;
      const trafficbackSettings = `
  <script>
    window.addEventListener('phv2site.native_web_push', (e) => {
      ${this.trafficSettingsCondiditions}
    });
  &lt;/script>`;
      if (this.customRedirect) {
        code += `\n${customRedirect}`;
      }
      if (this.trafficSettings.trafficback_settings) {
        code += `\n${trafficbackSettings}`;
      }
      return code.replaceAll("&lt;", "<");
    },
  },
  methods: {
    selectMode(mode) {
      this.mode = mode;
      this.modeSelected = true;
    },
    // Opens self-hosted for a partner who already uses it, unless they picked a tab before the status came
    onSelfHostedStatus(status) {
      if (!this.modeSelected && status && (status.downloaded || status.auto_sync_active)) {
        this.mode = "self_hosted";
      }
    },
    getUrlTemplates() {
      ServicePanel.getUrlTemplates().then((res) => {
        if (res && res.status === 200) {
          this.templates = res.data;
        }
      });
    },
    async getOnClick(id) {
      try {
        const resp = await siteSettingsService.getOnClick(id);
        if (resp && resp.status === 200) {
          this.customRedirect = resp.data.type === "new_tab_left_with_redirect";
        }
      } catch (error) {
        console.log(error);
      }
    },
    copy() {
      if (this.platform.site) {
        this.$helper.copyCode("htttpsCopyCode");
      } else {
        this.$helper.copyCode("htttpsCopyLink");
      }
      this.$alert({
        title: this.$t("copied_succ"),
        type: "success",
      });
    },
    toggleMacros(macros) {
      let query = `&${macros.name}=${macros.value}`;
      let variable = this.platform.site ? "code" : "link";
      if (this[variable].includes(query)) {
        this.oldMacroses[macros.value].enable = false;
      } else {
        this.oldMacroses[macros.value].enable = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.buttons-wrapper {
  position: absolute;
  right: 0;
  top: 0px;
  background: rgba(233, 242, 242, 0.15);
  width: 160px;
  height: 64px;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 12px;
  gap: 8px;
  border-bottom-left-radius: 20px;
  backdrop-filter: blur(5px);
  -moz-backdrop-filter: blur(5px);
  -ms-backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);

  &.arbitrage {
    width: 86px;
  }
}
.mobile-buttons-wrapper {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.tubs-content {
  position: relative;

  &__buttons-wrapper {
    position: relative;

    .buttons-wrapper {
      display: flex;
      gap: 8px;
      position: absolute;
      right: 8px;
      top: 8px;
      @media (max-width: 768px) {
        bottom: -54px;
        right: 0;
      }
    }

    .btn,
    .btn-settings {
      position: static;
    }
  }
}

.scroll-on {
  overflow-y: auto;
}
</style>
